<template>
    <div class="download-csv">
        <div class="download-csv__info">
            <div class="download-csv__info-title">
                {{ info.create.title }}
            </div>
            <div class="download-csv__info-subtitle">
                {{ info.create.subtitle }}
            </div>
        </div>
        <div class="download-csv__action">
            <pendo-button
                theme="app"
                type="secondary"
                class="ask-pendo-next-actions__button"
                size="small"
                @click="downloadCsv">
                {{ $t('askPendo.nextActions.Download_csv') }}
            </pendo-button>
        </div>
    </div>
</template>

<script>
import { PendoButton } from '@pendo/components';
import { getCustomerIds, escapeCsv, downloadFile } from '@/ask-pendo/next-actions/next-actions-utils.js';

export default {
    components: { PendoButton },
    props: {
        customers: {
            type: Object,
            required: true,
        },
    },
    data () {
        const info = Object.freeze({
            create: {
                title: this.$t('askPendo.nextActions.Download_csv'),
                subtitle: this.$t('askPendo.nextActions.Download_csv_subtitle'),
            },
        });

        return {
            info,
        };
    },
    methods: {
        downloadCsv () {
            const customerIds = getCustomerIds(this.customers);

            // Build simple CSV with header and one column of Visitor IDs
            const header = ['Visitor ID'];
            const rows = customerIds.map((id) => [id]);
            const lines = [header, ...rows].map((cols) => cols.map(escapeCsv).join(','));
            const csv = lines.join('\n');

            downloadFile(csv, 'customer-finder.csv');
        },
    },
};
</script>

<style scoped lang="less">
.download-csv {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__info-title {
        color: var(--palette-gray-100);
        font-weight: 600;
        font-size: 13px;
        line-height: 18px;
    }

    &__info-subtitle {
        color: var(--palette-gray-70);
        font-size: 12px;
        line-height: 18px;
    }
}
</style>
